<template><div><code-well-header>
  <div>
    <dt-collapsible
      class="d-fc-primary"
      anchorText="Label 1"
      maxWidth="340px"
      initial-focus-element="first"
      >
      <template #content>
        <div class="d-ta-center d-ba d-bc-gold-400 d-bgc-gold-100 d-bas-dotted d-baw2 d-p8 d-code--sm">(content slot)</div>
      </template>
    </dt-collapsible>
    <dt-collapsible
      anchorText="Label 2"
      maxWidth="340px"
      initial-focus-element="first"
    >
      <template #content>
        <div class="d-ta-center d-ba d-bc-gold-400 d-bgc-gold-100 d-bas-dotted d-baw2 d-p8 d-code--sm">(content slot)</div>
      </template>
    </dt-collapsible>
  </div>
</code-well-header>
<p class="d-docsite--paragraph">The collapsible component consists of two parts: the anchor and the content. If the anchor slot is not filled, the anchor will default to a basic button with text. The content must be provided and is the element that can be hidden or shown when the anchor is clicked.</p>
<h3 id="basic-usage-without-anchor-slot" tabindex="-1" class="d-docsite--header-3">Basic Usage Without Anchor Slot <a class="header-anchor d-link d-docsite--link d-link" href="#basic-usage-without-anchor-slot" aria-hidden="true">#</a></h3>
<code-well-header class="d-d-block">
  <dt-collapsible
    anchorText="Click me to toggle Content"
    ref="example-collapsible"
    >
    <template #content>
      <div>Content slot</div>
    </template>
  </dt-collapsible>
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs['example-collapsible']"
vueCode='
<dt-collapsible
  anchorText="Click me to toggle Content"
>
  <template #content>
    <div>Content slot</div>
  </template>
</dt-collapsible>
'
/>
<h3 id="with-anchor-slot" tabindex="-1" class="d-docsite--header-3">With Anchor Slot <a class="header-anchor d-link d-docsite--link d-link" href="#with-anchor-slot" aria-hidden="true">#</a></h3>
<code-well-header class="d-d-block">
  <dt-collapsible :open="isOpen" ref="with-anchor-slot">
    <template #anchor>
      <dt-button @click="toggleIsOpen">
        Click Me!
      </dt-button>
    </template>
    <template #content>
      <div>
        This will be shown in the expanded area.
      </div>
    </template>
  </dt-collapsible>
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs['with-anchor-slot']"
vueCode='
<dt-collapsible :open="isOpen">
  <template #anchor>
    <dt-button @click="toggleIsOpen">
      Click Me!
    </dt-button>
  </template>
  <template #content>
    <div>
      This will be shown in the expanded area.
    </div>
  </template>
</dt-collapsible>
'
/>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="collapsible" /></div></template>


<script setup>
import { ref } from 'vue';

const isOpen = ref(false);

function toggleIsOpen () {
  isOpen.value = !isOpen.value;
}
</script>